import React from "react";
import {ScheduledSupplyTemplateDTO} from "../../../../models/ScheduledSupplyTemplateDTO";
import {OzonFilterToggle} from "../ui/OzonFilterToggle";
import {DOW_OPTIONS} from "../constants";

export function TemplatesSection({
                                     templatesToShow,
                                     isLoading,
                                     ozonFilter,
                                     setOzonFilter,
                                     onEdit,
                                     onDelete,
                                     innerRef,
                                 }: {
    templatesToShow: ScheduledSupplyTemplateDTO[];
    isLoading: boolean;
    ozonFilter: boolean;
    setOzonFilter: (v: boolean) => void;
    onEdit: (t: ScheduledSupplyTemplateDTO) => void;
    onDelete: (id: number) => void;
    innerRef: React.RefObject<HTMLDivElement | null>;
}) {
    return (
        <>
            <div ref={innerRef} style={{marginTop: 18}}>
                <h2 className="supplies-section-title">Шаблоны (расписание)</h2>
                <p className="supplies-section-note">
                    Шаблоны задают правила расписания (дни недели, интервал, фаза).{" "}
                    <b>Изменение или удаление шаблонов влияет на все будущие планируемые поставки</b>.
                </p>
            </div>

            <OzonFilterToggle name="templatesFilter" value={ozonFilter} onChange={setOzonFilter}/>

            <div className="admin-table-wrapper">
                <table className="admin_table supplies-table">
                    <thead>
                    <tr>
                        <th>Тип</th>
                        <th>Отправка</th>
                        <th>Приёмка</th>
                        <th>Интервал</th>
                        <th>Фаза</th>
                        <th>Действия</th>
                    </tr>
                    </thead>

                    <tbody>
                    {isLoading && (
                        <tr>
                            <td colSpan={6} className="admin-table-loading">
                                <span className="admin-spinner"/> Загрузка...
                            </td>
                        </tr>
                    )}

                    {!isLoading &&
                        templatesToShow.map((t) => (
                            <tr key={t.id}>
                                <td>{t.title}</td>
                                <td>{DOW_OPTIONS.find((d) => d.value === String(t.departureDow))?.label ?? t.departureDow}</td>
                                <td>{DOW_OPTIONS.find((d) => d.value === String(t.acceptanceDow))?.label ?? t.acceptanceDow}</td>
                                <td>{t.intervalWeeks === 2 ? "Раз в 2 недели" : "Еженедельно"}</td>
                                <td>{t.intervalWeeks === 2 ? String(t.phase) : "—"}</td>
                                <td>
                                    <div className="supplies-actions">
                                        <button
                                            className="admin-button-secondary admin-button-secondary--ghost"
                                            onClick={() => onEdit(t)}
                                        >
                                            Изменить
                                        </button>
                                        <button
                                            className="admin-button-secondary admin-button-secondary--danger"
                                            onClick={() => onDelete(t.id)}
                                        >
                                            Удалить
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}

                    {!isLoading && templatesToShow.length === 0 && (
                        <tr>
                            <td colSpan={6} className="admin-table-empty">
                                Шаблонов нет для выбранного фильтра.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </>
    );
}
